import r2wc from "@r2wc/react-to-web-component";
import { RVDetailContainer } from "../components/RVDetailContainer";

const RVDetailWebComponent = r2wc(RVDetailContainer, {
  props: {
    apiKey: "string",
    apiBaseUrl: "string",
    fleetId: "string",
    vehicleId: "string",
    searchParams: "json",
    vehicleName: "string",
    totalPrice: "number",
    initialCustomerData: "json",
    initialDeliveryState: "json",
    initialAddonIds: "json",
    initialInsuranceIds: "json",
    theme: "string",
    primaryColor: "string",
    onContinueToCheckout: "function",
    onBackToResults: "function",
    onImageClick: "function",
    onCalendarDateRangeChange: "function",
    onDeliveryStateChange: "function",
    onSelectionsChange: "function",
  },
  events: {
    onContinueToCheckout: { bubbles: true, composed: true },
    onBackToResults: { bubbles: true, composed: true },
    onImageClick: { bubbles: true, composed: true },
    onCalendarDateRangeChange: { bubbles: true, composed: true },
    onDeliveryStateChange: { bubbles: true, composed: true },
    onSelectionsChange: { bubbles: true, composed: true },
  },
});

if (!customElements.get("fm-rv-detail")) {
  customElements.define("fm-rv-detail", RVDetailWebComponent);
}
